import { createContext, useContext, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { BudgetProgramCreateEditState, BudgetProgramCreateEditReducer, ACTION_TYPES } from './budget-program-create-edit-reducer';
export { ACTION_TYPES };

const BudgetProgramCreateEditContext = createContext<BudgetProgramCreateEditState | undefined>(undefined);
const BudgetProgramCreateEditDispatchContext = createContext({} as any);

export const BudgetProgramCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { budgetProgramId } = useParams();

    const initialState: BudgetProgramCreateEditState = {
        budgetProgramId,
        budgetProgramRequest: {},
        budgetUnits: [],
        showValidationErrors: false,
    };

    const [state, dispatch] = useReducer(BudgetProgramCreateEditReducer, initialState);

    return (
        <BudgetProgramCreateEditContext.Provider value={state}>
            <BudgetProgramCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </BudgetProgramCreateEditDispatchContext.Provider>
        </BudgetProgramCreateEditContext.Provider>
    );
};

export const useBudgetProgramCreateEditState = () => {
    const context = useContext(BudgetProgramCreateEditContext);
    if (context === undefined) throw new Error('useBudgetProgramCreateEditState must be used within BudgetProgramCreateEditProvider');
    return context;
};

export const useBudgetProgramCreateEditDispatch = () => {
    const context = useContext(BudgetProgramCreateEditDispatchContext);
    if (context === undefined) throw new Error('useBudgetProgramCreateEditDispatch must be used within BudgetProgramCreateEditProvider');
    return context;
};
